import { Engine } from "../engine/engine";
import { initialLocation } from "../engine/pincerjs";

/*
The plain, accessible client: the engine with no designs, so every node is drawn generically. It's the reference
renderer (whatever the tree becomes, it shows it) and a testbed for accessibility. See docs/accessibility.md.
*/
const engine = new Engine(new pincerjs.PincerApp(), document.getElementById("app")!, {
  announce: document.getElementById("announce")!,
});
engine.start(initialLocation());
